import { clearTokens, getToken } from '../lib/token-store.js';

export async function logoutCommand(): Promise<void> {
  const token = await getToken();

  if (!token) {
    console.log('Not logged in.');
    return;
  }

  // WAYAI_TOKEN env override survives clearTokens — surface that so the user
  // knows the current shell is still authenticated.
  const envOverrideActive = !!process.env.WAYAI_TOKEN;

  await clearTokens();

  if (envOverrideActive) {
    console.log('Tokens cleared from keyring and file. Note: WAYAI_TOKEN env var is still set in this shell — unset it to fully log out.');
  } else {
    console.log('Logged out. Tokens cleared.');
  }
}
